"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gapWorkbookUploadDeletedSchema = exports.allGapWorkbookUploadsSchema = exports.gapWorkbookUploadAdminRowSchema = exports.myGapWorkbookUploadsSchema = exports.gapWorkbookUploadSchema = exports.gapWorkbookUploadParamsSchema = exports.gapWorkbookUploadBodySchema = exports.gapWorkbookUploadHeadersSchema = exports.GAP_WORKBOOK_FILE_NAME_HEADER = void 0;
// J-320 (Louis, 2026-10-23): the wire shapes of Gap Workbook Uploads, served under `/api/v1`:
//   POST   /me/gap-workbook-uploads             the workbook as `application/octet-stream`, its file name in
//                                               the `x-file-name` header, percent-encoded (never in the URL)
//   GET    /me/gap-workbook-uploads             the caller's own uploads, newest first
//   DELETE /me/gap-workbook-uploads/:uploadId   the caller's own upload, with its stored bytes
//   GET    /gap-workbook-uploads                every user's uploads, newest first (the admin)
//   GET    /gap-workbook-uploads/:uploadId/file the stored workbook as an attachment (the admin)
// No shape carries a cell value. The file name is the uploader's label: shown on the two lists, sent as the
// download's file name, and never written to a log line, an audit row or a URL.
const zod_1 = require("zod");
/** The request header that carries the workbook's file name, `encodeURIComponent` of the name. */
exports.GAP_WORKBOOK_FILE_NAME_HEADER = "x-file-name";
/**
 * The header as sent: percent-encoded, so printable ASCII only. The service decodes and checks it. Loose: Fastify
 * replaces the request's headers with the parsed value, and a strict object would drop every other header.
 */
exports.gapWorkbookUploadHeadersSchema = zod_1.z.looseObject({
    [exports.GAP_WORKBOOK_FILE_NAME_HEADER]: zod_1.z
        .string()
        .min(1)
        .max(2048)
        .regex(/^[\x21-\x7e]+$/, "a percent-encoded file name"),
});
/** The workbook's bytes, `application/octet-stream`; the route's bodyLimit is `GAP_WORKBOOK_MAX_BYTES`. */
exports.gapWorkbookUploadBodySchema = zod_1.z
    .custom((value) => Buffer.isBuffer(value) && value.length > 0, "a non-empty file")
    .meta({ type: "string", format: "binary" });
exports.gapWorkbookUploadParamsSchema = zod_1.z.object({ uploadId: zod_1.z.uuid() });
/** One upload as its uploader lists it. */
exports.gapWorkbookUploadSchema = zod_1.z
    .object({
    uploadId: zod_1.z.uuid(),
    fileName: zod_1.z.string(),
    /** ISO 8601 with offset; the screen shows it in Eastern time. */
    uploadedAt: zod_1.z.iso.datetime({ offset: true }),
    sizeBytes: zod_1.z.number().int().positive(),
})
    .meta({ id: "GapWorkbookUpload" });
exports.myGapWorkbookUploadsSchema = zod_1.z
    .object({
    uploads: zod_1.z.array(exports.gapWorkbookUploadSchema),
    /** `GAP_WORKBOOK_MAX_BYTES`: a larger file is refused with 413, so the screen says the limit. */
    maxBytes: zod_1.z.number().int().positive(),
})
    .meta({ id: "MyGapWorkbookUploads" });
/** One upload as the admin lists it: who uploaded it, too. */
exports.gapWorkbookUploadAdminRowSchema = exports.gapWorkbookUploadSchema
    .extend({ uploadedBy: zod_1.z.object({ name: zod_1.z.string(), email: zod_1.z.string() }) })
    .meta({ id: "GapWorkbookUploadAdminRow" });
exports.allGapWorkbookUploadsSchema = zod_1.z
    .object({ uploads: zod_1.z.array(exports.gapWorkbookUploadAdminRowSchema) })
    .meta({ id: "AllGapWorkbookUploads" });
exports.gapWorkbookUploadDeletedSchema = zod_1.z
    .object({ uploadId: zod_1.z.uuid(), deleted: zod_1.z.literal(true) })
    .meta({ id: "GapWorkbookUploadDeleted" });
//# sourceMappingURL=gap-workbook-uploads.js.map